import React from 'react';
import Header from './Header';

export default function Layout({ children }) {
    return (
        <>
            <Header />
            <div style={{padding: 20,marginTop: 25}}>{children}</div>
        </>
    );
}
